import 'bootstrap/js/dist/collapse';
import { isEmpty } from 'lodash-es';

function load() {
  document.querySelectorAll('[data-toggle="collapse"][data-turbo-frame]').forEach(($el) => {
    $el.addEventListener('click', async () => {
      let turboFrame = document.querySelector(`#${$el.dataset.turboFrame}`);
      if (!turboFrame || await turboFrame.loaded)
        return;

      turboFrame.setAttribute('src', $el.getAttribute('href'));
    });
  });

  document.querySelectorAll('[data-toggle="collapse"]').forEach(($el) => {
    let target = $el.nodeName === 'A' && !!$el.getAttribute('href') && $el.getAttribute('href').startsWith('#') ? $el.getAttribute('href') : $el.dataset.target;
    !isEmpty($el.dataset.hiddenText) && $(target).on('hide.bs.collapse', () => $el.innerHTML = $el.dataset.hiddenText);
    !isEmpty($el.dataset.shownText) && $(target).on('show.bs.collapse', () => $el.innerHTML = $el.dataset.shownText);
  });
}

document.addEventListener("turbo:frame-load", load);
document.addEventListener("turbo:load", load);